import React, {useState, useCallback, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import Quiz from './Quiz';

const useStyles = makeStyles(() => ({
    startBtn:{
        minWidth:'149px',
        width:'149px',
        marginTop:'37px',
        alignSelf:'center'
    },

    colDiv:{
        display:'flex',
        flexDirection:'column'
    }
}));

function QuizWrapper({
    quiz,
  shuffle,
  shuffleAnswer,
  showDefaultResult,
  onComplete,
  customResultPage,
  showInstantFeedback,
  continueTillCorrect,
  revealAnswerOnSubmit,
  allowNavigation,
  onQuestionSubmit,
  disableSynopsis,
  timer,
  allowPauseTimer,
  enableProgressBar,
  ...props
}) {
    const classes = useStyles();
    const { t } = props;
    const [start, setStart] = useState(false);
    const [questions, setQuestions] = useState(quiz.questions);
    const nrOfQuestions = quiz.nrOfQuestions && quiz.nrOfQuestions < quiz.questions.length
    ? quiz.nrOfQuestions
    : quiz.questions.length;

    const shuffleQuestions = useCallback((q) => {
        for (let i = q.length - 1; i > 0; i -= 1) {
          const j = Math.floor(Math.random() * (i + 1));
          [q[i], q[j]] = [q[j], q[i]];
        }
        return q;
    }, []);

    useEffect(() => {
        let newQuestions = quiz.questions;
    
        if (shuffle) {
          newQuestions = shuffleQuestions(newQuestions);
        }
    
        newQuestions.length = nrOfQuestions;
        newQuestions = newQuestions.map((question, index) => ({
          ...question,
          questionIndex: index + 1,
        }));
        setQuestions(newQuestions);
    }, [start]);


    return(
        <div style={{width:'100%'}}>
            {!start && (
                <div className={classes.colDiv}>
                    <h2>{quiz.quizTitle}</h2>
                    <span>{t('quiz.quizLibaray.landingHeaderText',{number:nrOfQuestions})}</span>

                    <button type="button" onClick={() => setStart(true)} className={`mainBtn ${classes.startBtn}`}>
                        {t('quiz.quizLibaray.startQuizBtn')}
                    </button>
                </div>
            )
            }

            {start && (
                <Quiz
                    questions={questions}
                    onComplete={onComplete}
                    allowNavigation={allowNavigation}
                    onQuestionSubmit={onQuestionSubmit}
                    timer={timer}
                    allowPauseTimer={allowPauseTimer}
                    enableProgressBar={enableProgressBar}
                    progressBarColor={quiz.progressBarColor}
                    quizTitle={quiz.quizTitle}
                    customResultPage={customResultPage}
                />
            )}
        </div>
    )
}

export default withTranslation('common')(QuizWrapper);